
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSQuotationBOMGrid extends Serenity.EntityGrid<POSQuotationBOMRow, any> {
        protected getColumnsKey() { return 'Retail.QuotationBOM'; }
        protected getDialogType() { return POSQuotationBOMDialog; }
        protected getIdProperty() { return POSQuotationBOMRow.idProperty; }
        protected getInsertPermission() { return POSQuotationBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSQuotationBOMRow.localTextPrefix; }
        protected getService() { return POSQuotationBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}